import type { FaireProductEntity } from "../../entity_types/product";

export const p_yv5uv926s9: FaireProductEntity = {
  token: "p_yv5uv926s9",
  type: "product",
  name: "Moissanite Diamond Ring: 925 Silver Handmade Jewelry",
  brandToken: "b_uq6uf6uvrw",
  brandName: "Jay Jools",
  imageUrl: "https://cdn.faire.com/fastly/5d87c564f7c71a312afc037be094f2ffdcd60f7466b04d5705e71417f7a19283.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d6ca9a31d2a5c119d528f34b59f847046b650410a2d72cd57c3aec33d751d8a7.jpeg",
    "https://cdn.faire.com/fastly/6af0d584f204ffa9a2654fa6da21df1902e0321c564628d70aed2183e3ad4edf.jpeg",
    "https://cdn.faire.com/fastly/764661b6fc06382f8b843a4ce46083fd46f9e85ff8744dd0fc80357f55e57229.jpeg",
    "https://cdn.faire.com/fastly/6f43066a318bba4593260fcc683bd75d4000f0477c0fdbaa7bcbb9bb5277875a.jpeg"
  ],
  priceDollars: 103.91,
  description: "Moissanite Diamond Round Shape Ring in 925 Sterling Silver, Handmade. This stunning handcrafted ring features a dazzling Moissanite Diamond that radiates brilliance and elegance. Perfect for engagements, anniversaries, or as a special treat for yourself. Each piece is meticulously designed for comfort and style, making it a timeless addition to any jewelry collection.\n\nProduct Details\n\nGemstone: Moissanite Daimond\nMetal: 925 Sterling Silver (SR1339)\nStyle: Ring\nPackaging: Gift-ready box included\n\nWhy Choose JAY JOOLS\n\nHandcrafted in our in-house studio\nMade with 100% genuine, natural gemstones\nHallmarked 925, with 92.5%+ pure silver guaranteed\nSuperior 1-micron plating for lasting quality\nAvailable in Silver, Gold, and Rose Gold—plated over solid 925 Sterling Silver.\n\nNote: As each stone is natural, slight variations in texture and color are expected, ensuring that every piece is unique. Stone quality will always match what’s shown.",
  tags: [],
  msrpDollars: 207.82,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:59:02.388Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
